import React from 'react'

/**
 * The house pull-quote:「--brand」left bar, an oversized opening quote mark,
 * display-serif text. The SAME rules the blog article body applies to a
 * `<blockquote>` (via `kiao-prose.css`) — `.kiao-quote` is that style's
 * standalone hook, so a marketing page quoting a user does not re-declare the
 * bar, the mark, or the weight.
 *
 * Requires `@kiao-voice/ui-kit/kiao-prose.css` to be imported by the page.
 */
export function PullQuote({
  children,
  cite,
  className,
}: {
  children: React.ReactNode
  /** Optional source line, rendered as a plain muted `<cite>`. */
  cite?: React.ReactNode
  className?: string
}) {
  return (
    <blockquote className={className ? `kiao-quote ${className}` : 'kiao-quote'}>
      {children}
      {cite ? <cite className="mt-2 block text-[length:var(--text-sm-plus)] font-normal text-[var(--muted)] not-italic">{cite}</cite> : null}
    </blockquote>
  )
}
